<template>
  
  <div class="creek-audio-player-mini" :class="{ 'creek-audio-playing': Audio && CurrentAudio.playable === false && CurrentAudio.state != 'loading'}">
    <button v-if="Audio" class="creek-button-main" type="button" @click="Creek.audio.file.toggle(API)">
      <span class="creek-audio-button-icon">
        <i v-if="CurrentAudio.playable === true" class="creek-audio-play-icon fa fa-play fa-fw"></i><i v-if="CurrentAudio.playable === false && CurrentAudio.state != 'loading'" class="creek-audio-pause-icon fa fa-pause fa-fw"></i><i v-if="CurrentAudio.state == 'loading'" class="creek-audio-loading-icon fa fa-circle-o-notch fa-fw fa-spin"></i>
          <!-- <i class="creek-audio-circle-icon fa fa-circle-o fa-stack-2x"></i> -->
      </span>
      <span class="creek-audio-button-label">Listen</span>
    </button>
    <div v-if="Audio===null || !Audio" class="creek-no-audio">No Audio</div>
  </div>

</template>

<script type="text/javascript">

import JSONP from 'jsonp';

export default {
  name: 'creek-audio-player-mini',
  props: ['media', 'broadcast', 'show'],
  data: function(){
    return {}
  },
  methods: {
    // No methods here. 
    // They're all in CreekAudioPlugin.js.
  },
  computed: {
    API(){
      return {
        Broadcast: this.broadcast,
        Media: this.Audio,
        Show: this.show,
      }
    },
    Audio(){
      
      // console.log("Audio:");
      // console.log(this.media);

      var media = this.media || null;
      var output = null;

      // Get audio from (1) Array of Media objects or (2) single Media object
      if (media && media[0] && media[0].attributes && media[0].attributes.type){
        for (var i = 0; i < media.length; i++) {
          if (media[i].attributes.type == "audio"){
            output = media[i];
            break;
          }
        }
      }else if(media && media.attributes){
        output = media;
      }else{
        console.log("NO AUDIO");
      }

      // !!! Add playable -- add this to CreekAudioPlugin.js instead?
      if(output !== null){
        output.playable = true;
      }

      return output;
    
    },
    CurrentAudio() {
      if(
        this.Creek.audio.file.API.Media !== null
        && this.API.Media !== null
        && this.Creek.audio.file.API.Media.id == this.API.Media.id
      ){
        return this.Creek.audio.file;
      }
      else {
        return this.Audio;
      }
    },
  },
  created: function () {

    return true;

  }
}
</script>
